import { BaseDropdown } from './component/BaseDropdown';
import { useDropdownOptions } from '../../hooks/useDropdownOptions';
import { BusinessDropdownProps } from './component/type';

const COLUMN_NAMES: string[] = ['Shipping Agent', 'Description'];

export const ShippingAgentDropdown = (props: BusinessDropdownProps) => {
  const shouldPreventApiCall = props.disabled || props.readOnly;

  const { options: shippingAgentOptions, loading } = useDropdownOptions({
    apiId: 'internal.v1.base-tables',
    operationId: 'GET /promptValues/{windowId}',
    labelAttribute: 'description',
    valueAttribute: 'shippingAgent',
    params: {
      windowId: 'shippingAgents',
    },
    shouldPreventApiCall,
  });

  return <BaseDropdown {...props} loading={loading} options={shippingAgentOptions} columnNames={COLUMN_NAMES} />;
};
